<div class="betslip-result-keep-placed__border"></div>
<div class="betslip-result-keep-placed__content">
    <ds-checkbox size="medium" [checked]="keepPlaced" (checkedChange)="onKeepPlacedChanged($event)"> {{ labelTitle }} </ds-checkbox>
</div>
